module.exports = __webpack_public_path__ + "static/media/Avenir-Black-Oblique.7faff7db.ttf";